module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjOUI5QjlCIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIj4KICAgICAgICA8cGF0aCBkPSJNNi4zNDMgNi4zNDNsMTEuMzE0IDExLjMxNE0xNy42NTcgNi4zNDNMNi4zNDMgMTcuNjU3Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/x-icon.svg
// module id = 935
// module chunks = 0